import { call, put, takeEvery } from '@redux-saga/core/effects';
import { getDataWithHeaders } from '../httpClient';
import { GET_ORDER } from '../actions/actionsTypes';
import {
  setOrder,
  updateOrderDiscount,
  updateOrderMordy,
  updateOrderNote,
  updateOrderVoucher,
} from '../slices/orderSlice/orderSlice';
import { GetOrderAction } from '../actions/getOrderAction';
import { LineItemType, setOpenOrderLineItems } from '../slices/lineItemsSlice/lineItemsSlice';
import camelcaseKeys from 'camelcase-keys';
import { getAvailableItemsAction } from '../actions/getAvailableItemsAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* getOrder(action: GetOrderAction) {
  try {
    const orderResponse = yield call(
      getDataWithHeaders,
      `/api/v1/orders/${action.orderId}`,
      action.headers
    );
    yield put(setOrder(camelcaseKeys(orderResponse, { deep: true })));

    if (orderResponse.status !== 'paid') {
      yield put(getAvailableItemsAction());
    }

    // Populate line items directly from response if present, otherwise fetch fallback
    if (orderResponse.line_items) {
      const lineItems = orderResponse.line_items.map((lineItem: any) => ({
        ...camelcaseKeys(lineItem),
        lineId: Math.floor(Math.random() * 10000),
      }));
      yield put(setOpenOrderLineItems(lineItems));
    } else {
      const lineItemResponse = yield call(
        getDataWithHeaders,
        `/api/v1/line_items/?order_id=${action.orderId}`,
        action.headers
      );
      const lineItems = [] as LineItemType[];
      lineItemResponse.forEach((lineItem: any) => {
        lineItem.lineId = Math.floor(Math.random() * 10000);
        lineItems.push(camelcaseKeys(lineItem));
      });
      yield put(setOpenOrderLineItems(lineItems));
    }

    // Populate note, discount, voucher, mordy from embedded JSON response
    if (orderResponse.note) {
      yield put(updateOrderNote(camelcaseKeys(orderResponse.note)));
    } else if (orderResponse.note_id) {
      const noteResponse = yield call(
        getDataWithHeaders,
        `/api/v1/notes/${orderResponse.note_id}`,
        action.headers
      );
      yield put(updateOrderNote(camelcaseKeys(noteResponse)));
    }

    if (orderResponse.discount) {
      yield put(updateOrderDiscount(camelcaseKeys(orderResponse.discount)));
    } else if (orderResponse.discount_id) {
      const discountResponse = yield call(
        getDataWithHeaders,
        `/api/v1/discounts/${orderResponse.discount_id}`,
        action.headers
      );
      yield put(updateOrderDiscount(camelcaseKeys(discountResponse)));
    }

    if (orderResponse.voucher) {
      yield put(updateOrderVoucher(camelcaseKeys(orderResponse.voucher)));
    } else if (orderResponse.voucher_id) {
      const voucherResponse = yield call(
        getDataWithHeaders,
        `/api/v1/vouchers/${orderResponse.voucher_id}`,
        action.headers
      );
      yield put(updateOrderVoucher(camelcaseKeys(voucherResponse)));
    }

    if (orderResponse.mordy) {
      yield put(updateOrderMordy(camelcaseKeys(orderResponse.mordy)));
    } else if (orderResponse.mordy_id) {
      const mordyResponse = yield call(
        getDataWithHeaders,
        `/api/v1/mordys/${orderResponse.mordy_id}`,
        action.headers
      );
      yield put(updateOrderMordy(camelcaseKeys(mordyResponse)));
    }

    action.navigate(`/checkout?id=${action.orderId}`);
  } catch (e) {
    yield put(resetUser());
    alert('Sorry, Login Expired! Please Login again');
    action.navigate('/login');
  }
}

export function* watchGetOrder() {
  yield takeEvery(GET_ORDER, getOrder);
}
